import React from 'react';
import styled, { keyframes } from 'styled-components';
import Link from 'components/_utility/Link/Link';
import { minBp } from '../../lib/theme';
// Stop styled-components passing primary prop into Link
const _Link = ({ primary, ...props }) => <Link {...props} />; // eslint-disable-line

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  width: 100%;
  padding: 10px 30px;
  height: 60px;
`;

export const Message = styled.span`
  color: #585a5f;
  font-size: 12px;
  text-align: center;
  display: inline-block;

  @media ${minBp('tablet')} {
    font-size: 15px;
  }
`;

export const CTA = styled(_Link)`
  color: #000;
  text-transform: uppercase;
  display: inline-block;
  font-weight: 700;
  font-size: 12px;
  text-decoration: none;
  position: relative;
  margin-left: 4px;

  @media ${minBp('tablet')} {
    font-size: 15px;
  }

  svg {
    height: 12px;
    width: 12px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -15px;

    @media ${minBp('tablet')} {
      height: 15px;
      width: 15px;
    }

    path {
      fill: #000;
    }
  }
`;
